import { Paragraph as TiptapParagraph } from 'tiptap'

const ALIGN_PATTERN = new RegExp(`(left|center|right|justify)`)

export const ParagraphNodeSpec = {
  attrs: {
    textAlign: { default: null },
    indent: { default: null },
    lineHeight: { default: null },
  },
  content: 'inline*',
  group: 'block',
  parseDOM: [
    {
      tag: 'p',
      getAttrs,
    },
  ],
  toDOM,
}

// @ts-ignore
function getAttrs(dom) {
  let { textAlign } = dom.style

  let align = dom.getAttribute('data-text-align') || textAlign || ''
  align = ALIGN_PATTERN.test(align) ? align : null

  const indent = parseInt(dom.getAttribute('data-indent'), 10) || 0

  return {
    textAlign: align,
    indent,
  }
}

function toDOM(node) {
  const { textAlign, indent } = node.attrs

  let style = ''
  const attrs = {}

  if (textAlign && textAlign !== 'left') {
    style += `text-align: ${textAlign};`
  }

  if (indent) {
    attrs['data-indent'] = indent
  }

  style && (attrs.style = style)

  return ['p', attrs, 0]
}

export default class Paragraph extends TiptapParagraph {
  get schema() {
    return ParagraphNodeSpec
  }
}

export const toParagraphDOM = toDOM
export const getParagraphNodeAttrs = getAttrs
